module.exports = __webpack_public_path__ + "frontend/static/media/placeholder.0b0db852.gif";